<template>
  <v-container fluid class="pa-0" style="margin-top: 2vh">
    <v-data-table
      :headers="headers"
      :items="packageList"
      :items-per-page="10"
      class="elevation-1"
      @click:row="onPackageClick"
      :search="search"
    >
      <template v-slot:top>
        <v-row class="upper-elements">
          <v-col class="d-flex align-center">
            <v-dialog persistent v-model="dialog" max-width="500px">
              <template v-slot:activator="{ on }">
                <v-btn class="ml-4" small v-on="on">Create {{ context }}</v-btn>
              </template>
              <v-card>
                <v-card-title>
                  <span class="headline">{{ formTitle }}</span>
                </v-card-title>

                <v-card-text>
                  <v-container>
                    <v-row>
                      <v-col cols="12" sm="6" md="8">
                        <v-text-field
                          v-model="editedItem.name"
                          label="Name"
                        ></v-text-field>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12" sm="6" md="8">
                        <v-text-field
                          v-model.number="editedItem.percentage"
                          label="Percentage amount"
                        ></v-text-field>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="blue darken-1" text @click="close"
                    >Cancel</v-btn
                  >
                  <v-btn color="blue darken-1" text @click="save(item)"
                    >Save</v-btn
                  >
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-col>
          <v-col cols="2" sm="2" md="2">
            <v-text-field
              dense
              v-model="search"
              append-icon="mdi-magnify"
              outlined=""
              label="Search"
              hide-details
              class="mr-4"
            ></v-text-field>
          </v-col>
        </v-row>
      </template>
      <template v-slot:[`item.name`]="{ item }">
        <tr>
          {{
            item.name
          }}
        </tr>
      </template>
      <template v-slot:[`item.action`]="{ item }">
        <v-icon size="18" class="mr-3" @click="editPackage(item, $event)"
          >edit</v-icon
        >
        <v-icon size="24" @click="deletePackage(item, $event)">close</v-icon>
      </template>
    </v-data-table>
  </v-container>
</template>

<script>
export default {
  name: "packageList",
  props: {
    packageList: {
      type: Array,
      required: true,
      default: function () {
        return {};
      },
    },
    context: {
      type: String,
      required: false,
      default: "package",
    },
  },
  components: {},
  data: function () {
    return {
      editedIndex: -1,
      editedItem: {
        id: 0,
        name: "",
        packageId: 0,
        projectsId: 0,
        percentage: 0,
      },
      defaultItem: {
        id: 0,
        name: "",
        packageId: 0,
        projectsId: 0,
        percentage: 0,
      },
      dialog: false,
      search: "",
    };
  },
  computed: {
    headers() {
      return [
        {
          text: this.context.toUpperCase(),
          align: "left",
          sortable: true,
          value: "name",
        },
        {
          text: "Percentage",
          value: "percentage",
          sortable: false,
          align: "right",
        },
        { text: "Actions", value: "action", sortable: false, align: "right" },
      ];
    },
    formTitle() {
      return this.editedIndex === -1
        ? "New " + this.context
        : "Edit " + this.context;
    },
  },
  watch: {
    dialog(val) {
      val || this.close();
    },
  },
  created: function () {
    this.$store.dispatch("ProjectPackagesStore/fetchPackages");
  },
  methods: {
    onPackageClick(packages) {
      const path = `/packages/${packages.id}`;
      if (this.$route.path !== path) this.$router.push(path);
    },

    editPackage(item, e) {
      e.stopPropagation();
      e.preventDefault();
      this.editedIndex = this.packageList.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },
    deletePackage(item, e) {
      e.stopPropagation();
      this.$store.dispatch("DialogStore/open", {
        title: "Delete " + this.context,
        header: false,
        subtitle: "Are you sure?",
        okText: "Ok",
        ok: () => {
          this.deleteItemAction(item);
        },
        cancelText: "Cancel",
      });
    },
    deleteItemAction(item) {
      const index = this.packageList.indexOf(item);
      this.$store
        .dispatch("ProjectPackagesStore/deletePackage", item.id)
        .then((res) => {
          this.packageList.splice(index, 1);
        });
    },

    close() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },

    save: async function () {
      if (this.editedIndex > -1) {
        //UPDATE
        //Object.assign(this.apartmentList[this.editedIndex], this.editedItem);
        this.$store.dispatch(
          "ProjectPackagesStore/updatePackage",
          this.editedItem
        );
      } else {
        //CREATE

        this.editedItem.projectsId =
          this.$store.state.ProjectStore.selectedProject.id;

        await this.$store.dispatch(
          "ProjectPackagesStore/addPackage",
          this.editedItem
        );
      }
      this.close();
    },
  },
};
</script>

<style lang="scss" scoped>
.upper-elements {
  margin-bottom: 0px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.12);
}
.v-data-footer {
  margin-bottom: 16px !important;
  border-bottom: 1px solid rgba(255, 255, 255, 0.12) !important;
}
</style>
